import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import iconPlus from "assets/images/icons/project-icons/Plus.svg";
// import { getAllGroups } from 'store/entities/groups/action';
import { getPayGroups, deletePayGroup, deleteMultiplePayGroups } from 'store/entities/payroll/payrollSetup/action';
import Table from 'components/__new/common/Table';
import DateFormat from 'utils/dateFormat';
import DropdownNew from "utils/dropdown";
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import { useLocation, useHistory } from 'react-router-dom';
import * as groupActions from "store/entities/groups/action";
import * as employeesActions from "store/entities/employees/action";
import SearchBox from 'components/__new/common/SearchBox';
import useUrlQueryParams from 'hooks/useUrlQueryParams';
import processParams from 'utils/processParams';
import DynamicHeadTag from 'components/__new/common/DynamicHeadTag';
import { TableContent } from 'components/__new/common/TableContent';
import DialogBox from 'utils/dialogBox';
import {  AddGroupModal, EditGroupModal } from "components/__new/groups/modals";
import TableEmptyData from "components/__new/common/TableEmptyData";
import { ReactComponent as IconDotH } from "assets/images/icons/project-icons/dots-v.svg";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useMultiSelect from "hooks/useMultiSelect";
import Maybe from "components/__new/common/Maybe";
import ContentLoading from "components/__new/common/ContentLoading";
import pluralize from "utils/pluralize";

const GroupsListing = () => {
    const history = useHistory()
    const location = useLocation();
    // eslint-disable-next-line
    const [query, setQuery] = useState('');    
    const { selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections } = useMultiSelect();
    const [selected, setSelected] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    
    const [isEditGroupOpen, setIsEditGroupOpen] = useState(false);
    const [isAddGroupOpen, setIsAddGroupOpen] = useState(false);
    const {urlQueryParams} = useUrlQueryParams();

    const [listParams, setListParams] = useState({});

    const dispatch = useDispatch()
    const { /* getAllGroupsLoading: loading, allGroups: { docs: groups }, */
        groupsDownloadLoading, groupsDownloadData } = useSelector(state => state.entities.groups)
    const { employees } = useSelector(state => state.entities.employees)
    const {getPayGroupData: payGroupsData, getPayGroupLoading: loading, deletePayGroupResponse, selectedPayGroup, deletePayGroupLoading, deleteMultiplePayGroupsLoading} = useSelector(state => state.entities.payrollSetup)
        
    const printComponentRef = useRef();
    const groupsDownloadRef = useRef();
    const allGroupIDs = payGroupsData?.data?.map(item => item.id)

    // const getGroups = () => {
    //     let params = {...listParams};
    //     params = processParams(urlQueryParams, params, "search", "string", "", "search");
    //     setListParams(params);      
    //     // dispatch(groupActions.getAllGroups(params));
    //     dispatch(groupActions.getGroupsB2b());
    // }
    
    const fetchPayGroups = () => {
        let params = {...listParams};
        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        setListParams(params);
        dispatch(getPayGroups(params));
    }
    
    const handleViewGroup = (e, group) => { 
        setSelectedGroup(group)
        history.push(`/people/groups/group-details/${group.id}`, { groupDetails: group });
    }
    
    const handleEditGroup = (e, group) => { 
        setSelectedGroup(group)
        setIsEditGroupOpen((prevState) => !prevState)
    }
     
    // const handleDeleteGroup = (e, id) => { 
        
    //  }
     
     const handleDeleteGroup = async (group) => {
        const result = await DialogBox({
			title: "Delete Group",
            content: <div className="text-lg color-[#4A5564]">Are you sure you want to perform this action?</div>,
            // content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{group.name}</span>? This action cannot be undone.</div>,
			buttonYes: "Yes",
            buttonYesClass: "btn-ep-red w-[170px]",
            buttonNoClass: "w-[170px] btn-transparent border border-ep-primary focus:ring-2 focus:ring-transparent ",
			buttonNo: "No",
		});
		if (result) {
            // dispatch(groupActions.deleteGroupB2b(group.id)).then(() => fetchPayGroups())
            dispatch(deletePayGroup(group.id)).then(() => fetchPayGroups())
        }
    }
    
    const bulkDeleteSchedule = async () => {
        const result = await DialogBox({
			title: "Delete Pay Groups 😰",
			content: <div className="delete-modal-text">Are you sure you want to delete {selections?.length} pay groups? This action cannot be undone.</div>,
			buttonYes: "Delete Selected",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            const selectedIds = selections.map((selection) => JSON.parse(selection).id);
            dispatch(deleteMultiplePayGroups({ids: selectedIds}));
        }
    }
    
    const groupDropdownData = [
        {
            title: "View Group Details",
            func: (e, group) => {handleViewGroup(e, group)}
        },
        {
            title: "Edit Group Details",
            func: (e, group) => {handleEditGroup(e, group)}
        },
        {
            title: "Delete Group",
            color: 'text-[#DC2626]',
            func: () => {}
        },
        ]
    
    

    const filteredGroups = payGroupsData?.data?.filter(group => {
        if (!query) {
            return true
        } else {
            return group?.name?.toLowerCase()?.includes(query.toLowerCase())
        }
    })?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

    const toggleSingleGroup = (id) => {
        const alreadyExists = selected?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = selected?.filter(item => item !== id)
            setSelected(filtered)
        } else {
            setSelected([...selected, id])
        }
    }

    const toggleEntireList = () => {
        if (selected.length !== allGroupIDs?.length) {
            setSelected(allGroupIDs)
        } else {
            setSelected([])
        }
    }


    
    useEffect(() => {
        // getGroups();
        fetchPayGroups();
        // eslint-disable-next-line
    }, [location])
    
    useEffect(() => {
        dispatch(employeesActions.getAllEmployees())
    }, [])
    
    useEffect(() => {
        if ((deletePayGroupResponse?.id !== "" && typeof deletePayGroupResponse?.id === "string") || (deletePayGroupResponse?.count !== undefined && typeof deletePayGroupResponse?.count === "number")){
            fetchPayGroups();
            clearSelections();
        }
        // eslint-disable-next-line
    }, [deletePayGroupResponse]);
    
// }

// useEffect(() => {
//     dispatch(getAllEmployees());
//     // eslint-disable-next-line
// }, [])
    

    return (
        <div>
            <DynamicHeadTag headerText="Company | Groups" headerDescription="" />
                {/* <ViewEmployeesGroupDetails 
                        setIsViewGroupOpen={setIsViewGroupOpen} 
                        isViewGroupOpen={isViewGroupOpen}
                        selectedGroup={selectedGroup}
                        data={employees?.employees}
                        getGroups={getGroups}
                    /> */}
                <EditGroupModal 
                        setIsEditGroupOpen={setIsEditGroupOpen} 
                        isEditGroupOpen={isEditGroupOpen}
                        selectedGroup={selectedGroup}
                        data={employees?.employees}
                        getGroups={fetchPayGroups}
                    />
                <AddGroupModal 
                setIsAddGroupOpen={setIsAddGroupOpen} 
                isAddGroupOpen={isAddGroupOpen}
                data={employees?.employees}
                getGroups={fetchPayGroups}
                />
             
            <div className="lg:flex">
                <div>
                    <div className="page-title text-ep-deep-dark">
                        Groups
                    </div>
                </div>
            </div>
            <div className="mt-6 box bg-white relative">
                <div className="flex items-center justify-start w-max">
                    <h3 className="font-medium leading-7 text-lg text-ep-black pr-4">Groups List</h3>
                    <p className="font-medium label h-6 text-sm text-ep-primary-600 " style={{background: '#00535C14'}}>
                        <ContentLoading
                            loading={loading}
                            data={<>{payGroupsData?.totalDocs ?? (" " || "-")} {pluralize(payGroupsData?.totalDocs, "group", "groups")}</>}
                        />
                    </p>
                </div>
                <div className={`mt-6 flex flex-wrap ${selections?.length > 0 ? "justify-start" : "justify-between"}`}>
                    <div className="flex-grow flex items-center">
                        <div className="flex">
                            <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleMultiSelectHeader} />
                        </div>
                        <div className="w-10 flex justify-center items-center">
                            <IconDotH className="h-6 svg-fill-ccc" />
                        </div>
                        <Maybe condition={selections?.length > 0}>
                            <div className="flex flex-wrap items-center">
                                <button type="button" onClick={bulkDeleteSchedule} className="dropdown-item dropdown-item-icon text-red-500" disabled={deleteMultiplePayGroupsLoading}>
                                    <Maybe condition={deleteMultiplePayGroupsLoading === true}>
                                        <FontAwesomeIcon icon="circle-notch" spin className="text-xl" style={{margin: "auto 0.5rem auto 0"}} />
                                    </Maybe>
                                    <Maybe condition={deleteMultiplePayGroupsLoading === false}>
                                        <IconTrash style={{height: "1.25rem", marginRight: "0.5rem"}} />
                                    </Maybe>
                                    Delete
                                </button>

                                <div className="mx-2 sm:mx-6">
                                    <div className="w-0.5 h-4 bg-gray-200"></div>
                                </div>

                                <div className="flex space-x-4">
                                    <div className="text-[#6C757D]">
                                        {selections?.length} selected
                                    </div>
                                    <button type="button" onClick={clearSelections}>
                                        <IconsTimes className="svg-fill-red" />
                                    </button>
                                </div>
                            </div>
                        </Maybe>
                        <Maybe condition={selections?.length === 0}>
                            <div className="w-full max-w-sm sm:mr-6">
                                <SearchBox placeholder="Search Pay Groups" name="search" extraUrlParams="page=1" />
                            </div>
                        </Maybe>
                    </div>
                    <div className="flex items-center flex-wrap space-x-6">
                        <div>
                            <DownloadAsCSV
                                ref={groupsDownloadRef}
                                tooltip="Download Groups"
                                filename="All groups.csv"
                                columns={[
                                    { label: "Group Name", key: "name" },
                                    { label: "Employee Count", key: "employeeCount" },
                                    { label: "Date Created", key: "createdAt" },
                                ]}
                                click={() => {
                                    dispatch(groupActions.downloadUserGroups({ ...listParams, page: 1, limit: 10000 })).then(() => {
                                        groupsDownloadRef.current?.downloadData()
                                    });
                                }}
                                loading={groupsDownloadLoading}
                                response={groupsDownloadData}
                            />
                        </div>

                        <div className="">
                            <button onClick={() => setIsAddGroupOpen((prevState => !prevState))} type="button" className="btn btn-md btn-ep-primary gap-2">
                                Add Group
                                <img src={iconPlus} alt="iconPlus" className="w-3 h-3 mr-2 inline" />
                            </button>
                        </div>
                        {/* <div>
                            <Print component={printComponentRef} />
                        </div> */}
                    </div>
                </div>
                <div className='mt-8 ' ref={printComponentRef}>
                    <Table>
                        <Table.Head>
                            {/* <th>
                            <div className="flex items-center mb-6 lg:mb-0">
                        <input
                            type="checkbox"
                            onChange={toggleEntireList}
                            checked={filteredGroups?.length > 0 && selected?.length === allGroupIDs?.length}
                            className="w-5 h-5 mr-3.5 form-checkbox float-left"
                        />
                    </div>
                            </th> */}
                            <th></th>
                            <th>Group Name</th>
                            <th>No. of Employees</th>
                            <th>Date Created</th>
                            {/* <th>Assigned to</th> */}
                            <th></th>
                        </Table.Head>
                        <Table.Body>
                            
                        <TableContent
                            colspan={8}
                            data={payGroupsData?.data}
                            loading={loading || deletePayGroupLoading || deleteMultiplePayGroupsLoading}
                            total={payGroupsData?.data?.length}
                            loadingText={`${deletePayGroupLoading ? "Deleting pay group" : deleteMultiplePayGroupsLoading ? "Deleting multiple pay groups" : "Loading groups"}`}
                            dataContent={payGroupsData?.data?.length}
                            emptyUI={
                                <TableEmptyData 
                                    actionButtonClicked={() => setIsAddGroupOpen((prevState => !prevState))}
                                    actionButtonText="Click here to create new group"
                                />
                            }
                        />
                        
                        {(!loading && !deleteMultiplePayGroupsLoading && !deletePayGroupLoading) && filteredGroups?.map((group) =>
                            <tr key={group.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        className="form-checkbox w-5 h-5 multi-select"
                                        onChange={getMultiSelectBody}
                                        checked={selections?.filter((selection) => JSON.parse(selection).id === group.id).length === 1}
                                        value={JSON.stringify(group)}
                                    />
                                </td>
                                <td>
                                    <div className='capitalize'>
                                        {group?.name}
                                    </div>
                                </td>
                                <td>
                                    <div className='flex items-center'>
                                        {group?.employees?.length}
                                    </div>
                                </td>
                                <td>
                                    {DateFormat(group.createdAt)}
                                </td>
                                {/* <td>
                                    <div className="flex gap-2">
                                        <div className="font-aeonik text-12px font-medium leading-18px text-center rounded-full bg-[#F9F5FF] text-[#6941C6] p-2">On-Demand Pay</div>
                                        <div className="font-aeonik text-12px font-medium leading-18px text-center rounded-full bg-[#EFF8FF] text-[#175CD3] p-2">Payroll</div>
                                        <div className="font-aeonik text-12px font-medium leading-18px text-center rounded-full bg-[#F8F9FC] text-[#363F72] p-2 hidden">Payroll - Pay Structure</div>
                                    </div>
                                </td> */}
                                <td>
                                    <DropdownNew flipSwitch={true}>
                                                <></>
                                                <div>
                                                    <div onClick={(e) => {handleViewGroup(e, group)}} className="dropdown-item">View Group Details</div>
                                                    <div onClick={(e) => {handleEditGroup(e, group)}} className="dropdown-item">Edit Group Details</div>
                                                    <div onClick={() => handleDeleteGroup(group)} className="dropdown-item text-red-500">Delete</div>
                                                </div>
                                    </DropdownNew>
                                </td>
                            </tr>
                        )}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </div>
    )
}

export default GroupsListing
